export default {
  space: 'pnvf523rlq5x',
  accessToken: 'xpp2oh19spOvFQnJ9yXxpIVVG-zHYBgKacKmf2nwp-A'
}